module.exports = __webpack_public_path__ + "5274e6cdb89f7e45c5b55377bb805fb7.svg";